module.exports = __webpack_public_path__ + "./docs/img/big-icon-var.f5dd1a13219287bed459306510545e57.svg";